<script lang="ts">
    export let height = "h-6";
    export let width = "w-6";
    export let strokeColor = "stroke-mdark";
    export let fillColor = "fill-mdark";
    export let hover = "group-hover:stroke-mblue group-hover:fill-mblue";
    export let strokeWidth = "0.1";
    export let classList = "aspect-ratio transition-all";
</script>

<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
    stroke-linecap="round"
    stroke-linejoin="round"
    stroke-width={strokeWidth}
    class="icon {height} {width} {strokeColor} {fillColor} {classList} {hover}"
>
    <path d="M13.9905 22.27H13.8605C9.4205 22.27 7.2805 20.52 6.9105 16.6C6.8705 16.19 7.1705 15.82 7.5905 15.78C8.0005 15.74 8.3705 16.05 8.4105 16.46C8.7005 19.6 10.1805 20.77 13.8705 20.77H14.0005C18.0705 20.77 19.5105 19.33 19.5105 15.26V8.73998C19.5105 4.66998 18.0705 3.22998 14.0005 3.22998H13.8705C10.1605 3.22998 8.6805 4.41998 8.4105 7.61998C8.3605 8.02998 8.0205 8.33998 7.5905 8.29998C7.1705 8.26998 6.8705 7.89998 6.9005 7.48998C7.2405 3.50998 9.3905 1.72998 13.8605 1.72998H13.9905C18.9005 1.72998 21.0005 3.82998 21.0005 8.73998V15.26C21.0005 20.17 18.9005 22.27 13.9905 22.27Z"/>
    <path d="M13.63 12.75H0.75C0.34 12.75 0 12.41 0 12C0 11.59 0.34 11.25 0.75 11.25H13.63C14.04 11.25 14.38 11.59 14.38 12C14.38 12.41 14.05 12.75 13.63 12.75Z"/>
    <path d="M11.3998 16.1001C11.2098 16.1001 11.0198 16.0301 10.8698 15.8801C10.5798 15.5901 10.5798 15.1101 10.8698 14.8201L13.6898 12.0001L10.8698 9.18009C10.5798 8.89009 10.5798 8.41009 10.8698 8.12009C11.1598 7.83009 11.6398 7.83009 11.9298 8.12009L15.2798 11.4701C15.5698 11.7601 15.5698 12.2401 15.2798 12.5301L11.9298 15.8801C11.7798 16.0301 11.5898 16.1001 11.3998 16.1001Z"/>
</svg>
